import { useState } from "react";

export function useChildOperation() {
  const [openCredit, setOpenCredit] = useState(false);
  const [openEditChild, setOpenEditChild] = useState(false);
  const [openSafetySetting, setOpenSafetySetting] = useState(false);
  const [openUnregister, setOpenUnregister] = useState(false);
  return {
    openCredit,
    setOpenCredit,
    openEditChild,
    setOpenEditChild,
    openSafetySetting,
    setOpenSafetySetting,
    openUnregister,
    setOpenUnregister,
  };
}
